import { render, staticRenderFns } from "./ICN004-04_zoom_down.vue?vue&type=template&id=5167f7d0&"
import script from "./ICN004-04_zoom_down.vue?vue&type=script&lang=js&"
export * from "./ICN004-04_zoom_down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports